import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonHTMLAttributes } from "react";

export default function PrimaryButton({
    className = "",
    disabled,
    children,
    success,
    loading,
    type = "button",
    ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
    success?: boolean;
    loading?: boolean;
}) {
    return (
        <button
            type={type}
            {...props}
            className={
                `inline-flex text-center justify-center shadow-sm gap-2 items-center rounded-md border border-transparent bg-blue4 px-4 py-2 text-xs uppercase tracking-widest text-white transition duration-150 ease-in-out font-semibold hover:bg-blue6 hover:text-white focus:bg-blue6 focus:outline-none focus:ring-2 focus:ring-blue6 focus:ring-offset-2 active:bg-blue3 ${
                    disabled && "opacity-25"
                } ` + className
            }
            disabled={disabled}
        >
            {loading && <span className="btn-spinner"></span>}
            {success && <FontAwesomeIcon icon={faCheck} />}
            {children}
        </button>
    );
}
